import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Menu, Container, Responsive, Dropdown } from 'semantic-ui-react';


const NavMobile = ({
    options,
    show
}) => (
    <Menu secondary size='large'>
        <Link to='/'>
            <Menu.Item header className='hooli-text-white' as='h2'>Paprika</Menu.Item>
        </Link>
        <Menu.Menu position={'right'}>
            <Menu.Item>
                <Dropdown item simple icon='content'>
                    <Dropdown.Menu>
                        {options.map(item => (
                            <div>
                                {item.value !== 'cancel' &&
                                    <Dropdown.Item as="a" text={item.text} content={item.text} href={item.path} />
                                }
                                {item.value === 'cancel' &&
                                    <Dropdown.Item as="a" text={item.text} content={item.text} onClick={show} />
                                }
                            </div>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
        </Menu.Menu>
    </Menu>
);


const NavDesktop = ({
    isHome,
    activeItem,
    options,
    handleItemClick,
    isAuth,
    show
}) => (
    <Menu secondary size='large' className={!isHome ? 'hooli-nav-blue' : ''}>
        <Link to='/'>
            <Menu.Item header className='hooli-text-white' as='h2'>Paprika</Menu.Item>
        </Link>
        {options.filter(item => item.value !== 'login' && item.value !== 'logout' && item.value !== 'signup').map(item => (
            <Menu.Item
                key={item.key}
                name={item.value}
                content={item.text}
                active={activeItem === item.value}
                onClick={item.value === 'cancel' ? show : handleItemClick}
                href={item.path}
                className='hooli-text-white' />
        ))}
        <Menu.Menu position='right'>
            {isAuth ? (
                    <Menu.Item
                        name='logout'
                        content='Logout'
                        active={activeItem === 'logout'}
                        onClick={handleItemClick}
                        href={"/logout"}
                        className={isHome ? 'hooli-text-blue' : 'hooli-text-white'} />
                ) :
                (
                    <div className='hooli-flex'>
                        <Menu.Item
                            name='signup'
                            content='Sign up'
                            active={activeItem === 'signup'}
                            onClick={handleItemClick}
                            className={isHome ? 'hooli-text-blue' : 'hooli-text-white'} />
                        <Menu.Item
                            name='login'
                            active={activeItem === 'login'}
                            onClick={handleItemClick}
                            href={"/login"}
                            className={isHome ? 'hooli-text-blue' : 'hooli-text-white'} />
                    </div>
                )
            }
        </Menu.Menu>
    </Menu>
);

export default class Nav extends Component {

    state = {activeItem : '', visible: false};

    handleItemClick = (e, { name }) => this.setState({activeItem: name});

    render() {

        const isHome = window.location.pathname === '/';
        const { activeItem } = this.state;
        const options = this.props.isAuth ?
            [
                { as: "a", key : 1, text : 'Overview', value : 'overview', path: '/home'},
                { as: "a", key : 2, text : 'Details', value : 'details', path: '/details'},
                { as: "a", key : 3, text : 'Add Accounts', value : 'add', path: '/account-select'},
                { as: "a", key : 4, text : 'SmartLink', value : 'smartlink', path: '/smartlink'},
                { as: "a", key : 5, text : 'Refresh Token', value : 'refresh', path: '/refreshTokens'},
                { as: "a", key : 6, text : 'Cancel Service', value : 'cancel', path: '#'},
                { as: "a", key : 7, text : 'Logout', value : 'logout', path: '/logout'},
            ] :
            [
                { as: "a", key : 1, text : 'How it Works', value : 'how', path: '#'},
                { as: "a", key : 2, text : 'Find Savings', value : 'savings', path: '#'},
                { as: "a", key : 3, text : 'Support', value : 'support', path: '#'},
                { as: "a", key : 4, text : 'Blog', value : 'blog', path: '#'},
                { as: "a", key : 5, text : 'Sign Up', value : 'signup', path: '#'},
                { as: "a", key : 6, text : 'Login', value : 'login', path: '/home'},
            ];


        return (
            <Container>
                <Responsive minWidth={993}>
                    <NavDesktop
                        isHome={isHome}
                        activeItem={activeItem}
                        options={options}
                        handleItemClick={this.handleItemClick}
                        isAuth={this.props.isAuth}
                        show={this.props.show}
                    />
                </Responsive>
                <Responsive maxWidth={992}>
                    <NavMobile options={options} show={this.props.show} />
                </Responsive>
            </Container>
        )

    }

}
